import {isSchemaTag, Tag} from 'folder-items/FileConstants';
import {SchemaField} from 'schemas/fields/SchemaFieldConstants';
import {AnonymousSchema} from 'schemas/SchemaConstants';

export function nonComputedFields(schema: AnonymousSchema): Array<SchemaField> {
  return schema.fields.filter((field) => !field.isComputed);
}

export function tagIsComputed(tag: Tag): boolean {
  return isSchemaTag(tag) && tag.tagSchemaField.isComputed;
}
